import defaultTexts from '../config/default-values';

export const setMetaTags = (node, lang) => {
    document.title = node[lang]?.title ? node[lang].title : defaultTexts[lang].title;
    setMetaByName('title', node[lang].meta_title || defaultTexts[lang].title);
    setMetaByName('description', node[lang].description || defaultTexts[lang].description);
    setMetaByProperty('og:type', node[lang].og_type);
    setMetaByProperty('og:title', node[lang].og_title || defaultTexts[lang].title);
    setMetaByProperty('og:description', node[lang].og_description || defaultTexts[lang].description);
    setMetaByProperty('og:url', node[lang].og_url);
    setMetaByProperty('og:image', node[lang].og_image);
    setMetaByProperty('og:image:alt', node[lang].og_image_alt);
    setMetaByName('robots', node[lang].not_indexing ? 'noindex, nofollow' : ' ');
};

export const setMetaByName = (key, value) => {
    if (value && value !== '') {
        document.querySelector(`meta[name="${key}"]`).setAttribute('content', value);
    }
};

export const setMetaByProperty = (key, value) => {
    if (value && value !== '') {
        document.querySelector(`meta[property="${key}"]`).setAttribute('content', value);
    }
};
